<template>
  <van-pull-refresh
    v-model="refreshing"
    @refresh="onRefresh"
    ref="refresh"
    :disabled="pullRefreshDisabled"
  >
    <!-- <template #loading>
      <AnimationLoadingWhale :loading="refreshing" />
    </template>
    <template #loosing>
      <AnimationLoadingWhale :loading="refreshing" />
    </template>
    <template #pulling>
      <AnimationLoadingWhale :loading="refreshing" />
    </template> -->

    <van-list
      v-model="loading"
      :finished="finished"
      :immediate-check="immediateCheck"
      @load="onLoad"
    >
      <section class="common-list-session-container">
        <slot />
      </section>
      <template slot="loading">
        <!-- <AnimationLoadmore
          :circleFm="{ background: theme }"
          v-show="!refreshing"
        /> -->
        <listStatus :loadingEnd="true" />
      </template>
      <template slot="finished">
        <template v-if="isNone">
          <slot name="none" v-if="$slots.none" />
          <noTeacherState v-else :text="emptyText" />
        </template>
        <!-- <span v-else>已加载全部</span> -->
        <template v-else>
          <slot name="finished" v-if="$slots.finished" />
          <listStatus v-else :loadingEnd="false" />
        </template>
      </template>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { List } from 'vant'
import { PullRefresh } from 'vant'
// import AnimationLoadingWhale from 'component/common/AnimationLoadingWhale.vue'
import listStatus from 'app/web/component/common/listStatus.vue'
import noTeacherState from 'app/web/component/consult/noTeacherState.vue'

export default {
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    // AnimationLoadingWhale,
    listStatus,
    noTeacherState
  },
  props: {
    theme: {
      type: String,
      default: '#118bd0'
    },
    page: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 10
    },
    immediateCheck: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array
    },
    pullRefreshDisabled: {
      type: Boolean,
      default: true
    },
    emptyText: {
      type: String,
      default: '没有找到对应的老师'
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false
    }
  },
  mounted() {
    // 只在第一页的情况下触发，因为外部有可能直接$list.finish()
    this.$watch(
      () => this.list,
      () => {
        if (!this.immediateCheck && +this.page === 1) {
          this.finished = this.list.length < this.size
        }
      },
      {
        immediate: true
      }
    )
  },
  methods: {
    // 外部调用，需保留
    refresh() {
      this.refreshing = true
      this.onRefresh()
    },

    // 外部调用，需保留
    finish() {
      this.finished = true
    },
    onLoad() {
      const success = finished => {
        this.loading = false
        this.finished = finished

        if (this.refreshing) {
          this.refreshing = false
        }
      }

      const fail = () => {
        this.error = true
      }

      this.$emit('load', this.refreshing ? 1 : this.page + 1, success, fail)
    },
    // onLoad() {
    //   setTimeout(() => {
    //     if (this.refreshing) {
    //       this.list = []
    //       this.refreshing = false
    //     }

    //     for (let i = 0; i < 10; i++) {
    //       this.list.push(this.list.length + 1)
    //     }
    //     this.loading = false

    //     if (this.list.length >= 40) {
    //       this.finished = true
    //     }
    //   }, 1000)
    // },
    onRefresh() {
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    }
  },
  computed: {
    isNone() {
      const { loading, list } = this
      return !loading && list.length === 0
    }
  }
}
</script>

<style></style>
